<template lang="pug">
main.detail-wrap
  template(v-if="!id")
    fq-ignore
  template(v-else)
    .detail-content
      .video-wrap(@contextmenu.prevent="() => false")
        //- Player(v-if="config.pageReady" :config='config')
        Player(ref="player" :config='config', @onPlayBury="handleBuryPlay" @onBury="handleBuryPlayer" @definitionChange="switchDefinition",@playbackrateChange="handlePlaybackrateChange", @switchSubTitle="switchSubTitle" @player="(playerInstance) => player = playerInstance" @openEpisode="openEpisode" @ended="onPlayEnded" @onPlayNextBtnClick="onPlayNextBtnClick")
        VipDialog(v-if="vipDialogVisible", :duration="playTime")
        .mask(v-if='isPlayEnd')
        //- .mask(v-if='playLinkError')
        //-   .tips
        //-     h2 解析失败
        //-     p 请刷新当前页面重试，若问题仍存在请扫描下方二维码到APP内观看
        //-     img(src='https://img.rr.tv/0.2939622039210308%E7%BC%BA%E7%9C%81.png')
      .episodes-wrap
        RelatedMovie(v-if="category === 0" :name='name' :list='refList')
          VipTip(@getDownloadLink="getDownloadLink")
        client-only
          Episodes(ref="episodes" v-if="category === 1" :name='name', :list="episodeVo", :showSetName="showSetName", :currentEpisode="currentEpisode", @episodeChanged="episodeChanged" @getDownloadLink="getDownloadLink" position="outplayer")
            VipTip(@getDownloadLink="getDownloadLink" :data-bury-params="JSON.stringify({ UM_Key_ButtonName: '开通VIP' })")
    .info-wrap
      .info
        .title {{name}}
        .tags
          .scroce(v-if="score !== '0.0'") {{score | formatScore}}
          .iconfont.icon-imdb
          .iconfont  &nbsp;·&nbsp;
          .type-area-cagegory {{yearAndArea}}
        .type-area-cagegory.category-line {{$t("detailPage.category")}}:&nbsp; {{categories}}
        .desc(ref="desc", :class='{ "desc-actived": descToggle}') {{introduction}}
          //- .expand(v-if="showToggleBtn", @click='handleToggle') {{descToggle ? '收起简介' : $t('detailPage.moreDesc')}}
          .expand(v-if="showToggleBtn", @click='handleToggle' :data-bury-params="JSON.stringify({ UM_Key_ButtonName: '内容更多' })") {{descToggle ? '' : $t('detailPage.moreDesc')}}
      .ercode-wrap
        //- p Watch in app
        //- img(src='https://img.rr.tv/0.8683289872808893pic_web_ma.png')
    .recommends(v-if='likeList && likeList.length')
      .subtitle(v-t='"detailPage.youMayLike"')
      ul.recommend-list
        li.video-item(v-for='(item,index) in likeList', :key='"like" + item.id' @click="clickLikes(item,index)")
          nuxt-link(:to="localePath('/detail/' + $semantic.type[item.category] + '/' + `${item.websiteParam||item.id}`)")
            VideoCard(:title='item.name', :img="item.coverVerticalUrl")

</template>

<script>
import config from '@/config'
import Player from '@/components/player/Player'
import axios from 'axios'
import { default as toWebVTT } from 'srt-webvtt'
import Episodes from '@/components/detail/episodes'
import RelatedMovie from '@/components/detail/related-movie'
import VipTip from '@/components/detail/vip-tip'
import VipDialog from '@/components/detail/vip-dialog'
import getStructuredJson from '@/util/structuredData'
import { UUID, formatSeconds } from '@/util/index'
import { mapGetters } from 'vuex'

const statusCfg = {
  1: '未开播',
  2: '定期更新',
  3: '连载中不定期更新',
  4: '已完结'
}
// 动态路由 params: { category: '0', drama: '93', episode: undefined }
export default {
  scrollToTop: true,
  async asyncData({ app, route, params, redirect, query, $ua, req }) {
    const { episode, drama, category } = params
    const { source } = query
    const newCategory = Number(category) >= 0 ? Number(category) : app.$semantic.typeId[category]
    const newDrama = drama?.split('-')?.[0]

    try {
      const params = { id: newDrama, category: newCategory || '0' }
      if (source === 'search') params.source = '5'
      let res = await app.$api.fetchDetail(params)
      const seoRes = await app.$api.queryKeyword()
      console.log('--------------res', res)
      return {
        newCategory,
        newDrama,
        currentEpisode: res.episodeVo[0],
        seoKeyword: seoRes.keyword,
        ...res
      }
    } catch (error) {
      console.log('detail error:', error)
      // console.error('detail-error: ', error)
      // redirect('/404')
    }
  },
  head() {
    return {
      title: this.name ? this.name + ' - ' + this.$t('seo.title') : this.$t('seo.title'),
      meta: [
        {
          name: 'keywords',
          content: `${this.name ? this.name + ' - ' : ''}${this.keyword ? this.keyword + ' - ' : ''}${this.seoKeyword ? this.seoKeyword + ',' : ''}${this.$t('seo.index.keywords')}`
        },
        {
          hid: 'description',
          name: 'description',
          content: this.introduction + this.$t('seo.description')
        },
        {
          rel: 'canonical',
          href: 'https://loklok.top' + this.localePath('/detail/' + this.$route.params.category + '/' + this.$route.params.drama + (this.$route.params.episode ? '/' + this.$route.params.episode : ''))
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: [
            getStructuredJson.bread([
              { name: this.$t('seo.index.title'), path: 'https://loklok.top' + this.localePath('/') },
              { name: this.name ? this.name + ' - ' + this.$t('seo.title') : this.$t('seo.title') }
            ])
          ]
        }
      ]
    }
  },
  components: {
    Player,
    Episodes,
    RelatedMovie,
    VipTip,
    VipDialog
  },
  data() {
    return {
      vipDialogVisible: false,
      downloadLinks: null,
      id: '',
      showLoginTip: true,
      currentEpisode: {
        // definitionList: [
        //   // { code: 'GROOT_SD', description: '720P', fullDescription: '720P' },
        //   // { code: 'GROOT_LD', description: '540P', fullDescription: '540P' }
        // ],
        // id: 0,
        // name: '',
        // resourceType: 0,
        // seriesNo: 0,
        // subtitlingList: [],
        // vid: ''
      },
      pageReady: false,
      config: {
        fluid: false,
        customConfig: {},
        autoplay: true,
        playNext: {
          urlList: ['url1', 'url2', 'url3']
        },
        id: 'xxplayer',
        url: '',
        poster: '',
        // 字幕列表
        textTrack: [
          // {
          //   src: 'https://subtitles.netpop.app/subtitles/20211227/1640576766658_低头遇见爱.WEBRip.Netflix.en.srt',
          //   kind: 'subtitles',
          //   label: '字幕1',
          //   srclang: 'zh',
          //   default: false
          // },
          // {
          //   src: 'http://localhost:3001/6bf4a7b3-eff5-4525-8650-2cd59bf34ab8dsdsds.vtt',
          //   kind: 'subtitles',
          //   label: '字幕2',
          //   srclang: 'en',
          //   default: true
          // }
        ]
      },
      currentMedia: {},
      // 当前视频可用字幕{en:'xxx', src:'xxx', default: true|false}
      currentSubtitle: {},
      currentSubtitleCode: '',
      currentDefinitionCode: '',
      currentEpisodeList: null,
      player: null,
      showToggleBtn: false,
      isPlayEnd: false,
      activatedEpisode: '',
      movieEpisodeMediaUrl: '',
      code: '',
      likeList: [],
      movieEpisodeInfoList: [],
      playLink: '',
      coverHorizontalUrl: '',
      title: '',
      descToggle: false,
      // videoSrc: 'https://img.rr.tv/0.804302636026013954b07e4659682592e4215b82aa4c99e9.mp4.f40.mp4',
      autoplay: false,
      requestTime: null
    }
  },
  computed: {
    ...mapGetters(['changeEpisodeHistory']),
    isLogin() {
      return this.$store?.state?.user?.token
    },
    playLinkError() {
      return !this.config.url
    },
    yearAndArea() {
      let areaList = this.areaNameList || []
      return areaList.concat(this.year)?.join(' · ')
    },
    categories() {
      return (this.tagNameList && this.tagNameList?.join(' · ')) || []
    }
  },
  filters: {
    formatScore(value) {
      if (!value || isNaN(Number(value))) return value
      return value.toFixed(1)
    }
  },
  methods: {
    clickLikes(item, index) {
      this.$store.commit('play/SET_NEWSERIES', true) //标记当前为切换新剧，避免清理前一个剧集播放记录之后 播放器再添加新的播放记录
      this.$store.commit('play/SET_ISCLICKPLAY', true)
      this.handleBury(item, index)
    },
    handleBury(item, index) {
      this.$LokBury.handleMD(
        {
          buryEventId: 'UM_Event_ContentClick',
          buryParams: {
            UM_Key_ContentName: item.name,
            UM_Key_ContentID: item.id,
            UM_Key_ContentType: this.$semantic.cnName[item.category],
            UM_Key_DistinctID: this.id,
            UM_Key_SourceChannel: '猜你喜欢',
            UM_Key_SourceSection: index + 1
          }
        },
        'click'
      )
    },
    resolveNums(arr = [], field) {
      const temp = arr.map((item) => (field ? item[field] : item))
      temp.sort((x, y) => x - y)
      return temp
    },
    // 处理当前清晰度
    handleGetDefinition() {
      const list = this.config.customConfig?.definitionList || this.episodeVo[0]?.definitionList || []
      return list.filter((item) => item.code === (this.currentDefinitionCode || 'GROOT_SD'))[0]?.description || '720P'
    },
    // 播放相关埋点
    handleBuryPlay(type, info = {}) {
      /**
       * info: -stage 阶段 -stuckTime 卡顿时间 -autoPlay 手动播放/'' -fullScreen 是否全屏 -rate 播放完成度 -continuous 连续播放集数
       * */
      let params = {
        UM_Key_VideoName: this.name,
        UM_Key_VideoID: this.$route.params.episode || this.episodeVo[0]?.id,
        UM_Key_SeasonID: this.id,
        UM_Key_UUID: UUID(),
        UM_Key_VideoCategory1: this.category,
        UM_Key_VideoCategory2: this.resolveNums(this.tagList, 'id').join('/'),
        UM_Key_VideoType: this.$semantic.cnName[this.category],
        UM_Key_PlayPage: '详情播放页',
        UM_Key_UpTime: this.year,
        UM_Key_State: statusCfg[this.updateInfo?.updateStatus],
        UM_Key_SetNumber: this.$route.params.episode ? this.episodeVo?.filter((item) => item.id === Number(this.$route.params.episode))?.[0]?.seriesNo || '第1集' : '第1集',
        UM_Key_AutoPlay: info.autoPlay || '自动播放',
        UM_Key_ContinuousPlay: info.continuous || this.changeEpisodeHistory.length ? `连续${this.changeEpisodeHistory.length + 1}集` : '连续1集',
        UM_Key_SourcePage: this.$route.meta.fromPage || this.$getInnerReferrerPage(), //上级页面
        UM_Key_SourceChannel: this.$route.query.channel ? `${this.$route.query.channel}#@#${this.$route.query.channelName}` : null,
        UM_Key_SourceSection: this.$route.query.section ? `${this.$route.query.section}#@#${this.$route.query.sectionName}` : null
      }
      if (type === 'playClick') {
        // 播放点击
        this.$LokBury.handleMD(
          {
            buryEventId: 'UM_Event_VideoPlayClick',
            buryParams: {
              ...params,
              UM_Key_Area: this.resolveNums(this.areaList, 'id').join('/')
            }
          },
          'click'
        )
      } else if (type === 'playProcess') {
        // 播放过程
        this.$LokBury.handleMD(
          {
            buryEventId: 'UM_Event_VideoPlayProcess',
            buryParams: {
              ...params,
              UM_Key_Area: this.resolveNums(this.areaList, 'id').join('/'),
              UM_Key_Stage: info.stage,
              UM_Key_VideoURL: this.currentMedia?.mediaUrl || this.player.src || this.config.url,
              UM_Key_PlayType: '在线',
              UM_Key_Definition: this.handleGetDefinition(),
              UM_Key_Trial: this.$store.state.user.userInfo.vip ? '否' : '是',
              UM_Key_StuckTime: info.stuckTime || null
            }
          },
          'click'
        )
      } else if (type === 'videoPlay') {
        // 播放完成上报
        this.$LokBury.handleMD(
          {
            buryEventId: 'UM_Event_VideoPlay',
            buryParams: {
              ...params,
              UM_Key_VideoURL: this.currentMedia?.mediaUrl || this.player.src || this.config.url,
              UM_Key_PlayType: '在线',
              UM_Key_FullScreen: info.fullScreen || null,
              UM_Key_AreaID: this.resolveNums(this.areaList, 'id').join('/'),
              UM_Key_Definition: this.handleGetDefinition(),
              UM_Key_SourceLocation: this.$route.query.section ? this.$route.query.sequence || null : null,
              UM_Key_Rate: info.rate || null,
              UM_Key_Duration: info.duration || null,
              UM_Key_VideoDuration: info.videoDuration || null,
              UM_Key_RequestTime: this.requestTime,
              UM_Key_ResponseTime: info.responseTime || null,
              UM_Key_FirstFrameTime: info.firstFrameTime || null,
              UM_Key_PlayEndTime: info.playEndTime || null,
              UM_Key_StartFrame: formatSeconds(Number(info.startFrame) || 0),
              UM_Key_PlaySpeed: info.playSpeed || null,
              UM_Key_Lang: info.lang || null
            }
          },
          'click'
        )
      }
      // else if (type === 'errors') {
      //   this.$LokBury.handleMD(
      //     {
      //       buryEventId: 'UM_Event_Errors',
      //       buryParams: {
      //       }
      //     },
      //     'click'
      //   )
      // }
    },
    handleBuryPlayer(btnName, Modular) {
      this.$LokBury.handleMD(
        {
          buryEventId: 'UM_Event_RealplayerClick',
          buryParams: {
            UM_Key_ButtonName: btnName,
            UM_Key_Modular: Modular
          }
        },
        'click'
      )
    },
    playerPause() {
      this.$refs.player.player.pause()
    },
    handleVipDialog(e) {
      if ([].includes.call(e.target.classList, 'active')) {
        this.playerPause()
        this.vipDialogVisible = true
      }
      if ([].includes.call(e.target.classList, 'iconfont')) {
        this.showLoginTip = false
        document.querySelector('.full-login-tip').remove()
      }
    },
    async getDownloadLink(isOpen = false) {
      if (process.client) {
        console.log('client')
        if (this.downloadLinks) {
          this.playerPause()
          if (this.$refs.player.player.fullscreen) {
            this.$refs.player.player.exitFullscreen()
          }
          this.$showDetailOpenVipFunction(this.downloadLinks)
          return
        }
        try {
          this.downloadLinks = await this.$api.fetchDownloadLink()
          if (this.downloadLinks && isOpen) {
            this.playerPause()
            if (this.$refs.player.player.fullscreen) {
              this.$refs.player.player.exitFullscreen()
            }
            this.$showDetailOpenVipFunction(this.downloadLinks)
          }
        } catch (error) {
          console.log('downloadLinks api is error')
        }
      }
    },
    goLogin() {
      this.$showLoginDialogFunction()
    },
    onPlayEnded() {
      // if (!this.isLogin) {
      //   this.$showLoginDialogFunction()
      // }
      if (!this.vip && this.category == 0) {
        this.playerPause()
        this.vipDialogVisible = true
        if (this.$refs.player.player.fullscreen) {
          this.$refs.player.player.exitFullscreen()
        }
      }
    },
    // 在全屏状态下，触发切集事件
    openEpisode() {
      document.querySelector('.full-screen-mask').classList.add('full-screen-mask-active')
      document.querySelector('.full-screen-mask .episode-item-active').scrollIntoView()
    },
    exitEpisodeFullscreen() {
      const fullScreenMask = document.querySelector('.full-screen-mask')
      // 全屏状态下，切集；会直接跳转页面；所以
      if (!fullScreenMask) return
      fullScreenMask?.classList?.remove('full-screen-mask-active')
      this.$refs['episodes']?.activeScrollToView()
    },
    loginTip() {
      setTimeout(() => {
        if (this.category == 0 && this.showLoginTip && !this.vip) {
          const fullLoginTip = document.querySelector('.full-login-tip') || document.createElement('div')
          fullLoginTip.className = 'full-login-tip'
          fullLoginTip.innerHTML = `<span>${this.$t('detailPage.vip.player.tip1', { num: this.playTime })}</span><i class="iconfont icon-ic_close"></i>`
          document.getElementById('xxplayer').appendChild(fullLoginTip)
          document.querySelector('.full-login-tip').onclick = (e) => {
            this.handleVipDialog(e)
          }
        }
      }, 1000)
    },
    onVideoFullScreen() {
      // 有遮罩就不创建
      const fullScreenMask = document.querySelector('.full-screen-mask') || document.createElement('div')
      fullScreenMask.className = 'full-screen-mask'
      document.getElementById('xxplayer').appendChild(fullScreenMask)
      const episodesModule = document.querySelector('.episodes-module')
      if (!episodesModule) return
      fullScreenMask.appendChild(episodesModule)
      fullScreenMask.addEventListener('click', () => {
        this.exitEpisodeFullscreen()
      })
      // fullScreenMask.classList.add('episodes-module-active')
      document.querySelector('.episodes-module').addEventListener('click', (e) => {
        // 阻止冒泡
        e.stopPropagation()
      })
    },
    onExitVideoFullScreen() {
      const episodesModule = document.querySelector('.episodes-module')
      if (!episodesModule) return
      document.querySelector('.episodes-wrap').appendChild(episodesModule)
      this.exitEpisodeFullscreen()
    },
    goDetail(id) {
      window.location.href = `/detail/${id}`
      // this.$router.push(`/detail/${id}`)
      this.$refs.episodes?.scrollTo(0, 0)
    },
    onPlayNextBtnClick() {
      // this.player.playNext()
      const currentIndex = this.episodeVo.map((item) => item.id).indexOf(this.currentEpisode.id)
      this.episodeChanged(this.episodeVo[currentIndex + 1])
    },
    async episodeChanged(episode) {
      console.log('episodeChanged:', episode, this.$route)
      this.$store.commit('play/SET_ISCLICKPLAY', true)
      const { category, drama } = this.$route.params
      this.$router.push(this.localePath(`/detail/${category}/${drama}/${episode.id}`))
      // this.player.currentTime = 0

      // // TODO提示正在切换集
      // this.currentEpisode = episode
      // // TODO 切集，先获取url再setUrl
      // await this.initPlayer()
      // TODO提示切换集成功
      // this.fetchMoviePlayInfo(episode.definitionList.reverse()[0].code, episode.id)
    },
    // 切换清晰度
    async switchDefinition(definition) {
      // TODO提示正在切换清晰度
      // this.player.switchDefinition(definition)
      console.log('switchDefinition:', definition)
      const definitionTo = this.getDefinitionCode(definition.to)
      console.log('switchDefinition  to:', definitionTo)
      const playLink = await this.fetchMoviePlayInfo(definitionTo)
      // 切换播放链接；和初始化不一样；初始化直接在config里面设置url
      this.player.src = playLink
      // TODO提示切换清晰度成功
    },
    initDefinition() {
      this.config.customConfig.definitionList = this.currentEpisode?.definitionList?.map((item) => {
        return {
          name: item.description,
          // 将当前清晰度url和 confing.url保持一致，清晰度才能显示出来
          url: this.currentMedia?.currentDefinition === item.code ? this.currentMedia.mediaUrl : item.code,
          code: item.code
        }
      })
    },
    getDefinitionCode(name) {
      console.log('getDefinitionCode:', name)
      return this.config.customConfig.definitionList.filter((item) => item.name === name)[0]?.code
    },
    getCurrentEpisodeDefaultDefinition() {
      // 目前看大部分都是 优先取720P，没有720P就从最低取
      // [
      //   { code: 'GROOT_HD', description: '1080P', fullDescription: '1080P' },
      //   { code: 'GROOT_SD', description: '720P', fullDescription: '720P' },
      //   { code: 'GROOT_LD', description: '540P', fullDescription: '540P' }
      // ]
      // 先判断上一集使用的清晰度当前集有没
      const hasPreviousDefinition = this.currentEpisode?.definitionList?.some((item) => item.code === this.currentDefinitionCode)
      if (hasPreviousDefinition) return this.currentDefinitionCode
      // 没有再判断有没有720p，有就取720p，没有就取最低清晰度
      const has720P = this.currentEpisode?.definitionList?.some((item) => item.code === 'GROOT_SD')
      if (has720P) return 'GROOT_SD'
      return this.currentEpisode?.definitionList?.map((item) => item.code).reverse[0]
    },
    async fetchMoviePlayInfo(defintion) {
      const params = {
        category: this?.category || this.newCategory,
        contentId: this?.id || this.newDrama,
        definition: defintion || this.getCurrentEpisodeDefaultDefinition() || 'GROOT_SD',
        episodeId: this.currentEpisode?.id
      }
      this.requestTime = new Date().getTime()
      let mediaInfo = await this.$api.fetchPlayLink(params).catch(() => {
        this.handleBuryPlay('playProcess', { stage: 3, autoPlay: this.startClickPlay ? '手动点击' : '自动播放' })
      })
      if (mediaInfo?.mediaUrl?.indexOf('a2e453101afb71eebfb136a5e8aa0102') > -1) {
        mediaInfo.mediaUrl = ''
        this.getDownloadLink()
      }
      // if (this.$store?.state?.user?.token) {
      //   mediaInfo = await this.$api.fetchPlayLink(params)
      // } else {
      //   mediaInfo = await this.$api.fetchPlayLinkPreview(params)
      // }
      console.log('playInfo:', mediaInfo)
      // 存个变量，方便切换集的时候使用
      this.currentDefinitionCode = mediaInfo?.currentDefinition
      this.currentMedia = mediaInfo
      // 给播放器设置地址
      this.handleBuryPlay('playProcess', { stage: 2, autoPlay: this.startClickPlay ? '手动点击' : '自动播放' })
      return this.currentMedia?.mediaUrl
      // this.initDefinition()
      // this.config.url = 'http://localhost:3000/Spider.Man.No.Way.Hom.mp4'
    },
    //
    handlePlaybackrateChange(item) {
      console.log('playbackrateChange', item)
    },
    // 初始化字幕
    async initSubtitles() {
      const list = await this.getFormatedSubtitle()
      this.config.textTrack = list
    },
    // 切换字幕
    async switchSubTitle(item) {
      // {id: 'en', language: 'English'}
      // language是实际展示的名字：English |简体中文| 繁体中文;this.currentEpisode.subtitlingList[0].language是实际的语言编码
      console.log('switchSubTitle:', item)
      // TODO: 切换字幕提示
      const list = await this.getFormatedSubtitle(item.id)
      this.player.setSubTitles(list)
      // TODO: 切换字幕成功提示
    },
    // 格式化字幕列表；切换和初始化都调这个方法
    async getFormatedSubtitle(code) {
      const _this = this
      const subtitles = this?.currentEpisode?.subtitlingList ?? []

      let localSubtitleLang = (code || localStorage.getItem('loklok_subtitle_code')) ?? 'en'
      localStorage.setItem('loklok_subtitle_code', localSubtitleLang)
      const codeList = subtitles.map((item) => item.languageAbbr)
      // 如果当前字幕不在列表里面，就取第一个
      if (!codeList.includes(localSubtitleLang)) {
        localSubtitleLang = codeList[0]
      }
      this.currentSubtitleCode = localSubtitleLang
      if (!subtitles.length) return
      let realList = subtitles?.map((item) => {
        return {
          src: item.subtitlingUrl,
          label: item.translateType === 1 ? `${item.language} (${_this.$t('detailPage.autoTranslation')})` : item.language,
          id: item.languageAbbr,
          default: item.languageAbbr === localSubtitleLang
        }
      })
      this.currentSubtitle = realList.filter((item) => item.default)[0]
      if (!this.currentSubtitle) return []
      console.log('currentSubtitle:', this.currentSubtitle)
      const srt = await axios.get(this.currentSubtitle.src)
      // const srt = await axios.get('http://localhost:3001/1650345162791_1647843421263_ms-9bbec2bb-9611-4eec-bdc5-50e46db5ad70的副本.srt')
      console.log('srt内容:', srt)
      const formatedSrt = srt.data
        .split('\n')
        .map((item) => {
          return !item ? item : item.match(/(\d\d:\d\d:\d\d),(\d\d\d)/g)?.length === 2 ? item : item.replace(/>/g, '›')
        })
        .join('\n')
      console.log('formatedSrt内容:', formatedSrt)
      // 字幕文件中有除了 '-->' 以外的 '>' 就会导致字幕解析失败
      // var myblob = new Blob([srt.data.replace(/[^--]>/g, '')], {
      //   type: 'text/plain'
      // })
      var myblob = new Blob([formatedSrt], {
        type: 'text/plain'
      })
      // 获取到字幕后将srt字幕转换成vtt字幕
      const textTrackUrl = await toWebVTT(myblob)
      console.log('vtt内容:', textTrackUrl)
      realList.forEach((element) => {
        if (element.default) {
          element.src = textTrackUrl
        }
      })
      console.log('格式化后的字幕列表:', realList)
      return realList
    },

    handleToggle() {
      this.descToggle = !this.descToggle
    },
    onDownload() {
      window.open('/download_nd')
    },
    setVideoPlayerSize() {
      const videoElement = document.querySelector('video')
      videoElement.style.height = `${videoElement.offsetWidth * 0.6}px`
    },
    async initPlayer() {
      // 判断播放器是否有切集按钮
      if (this.newCategory === 1) {
        this.config.customConfig.hasEpisode = true
      }
      // 判断播放器是否有下一集按钮
      console.log('initPlayer:')
      if (this.newCategory === 1 && this.currentEpisode.id !== this.episodeVo?.map((item) => item).reverse()[0]?.id) {
        this.config.customConfig.hasPlayNext = true
      }
      this.config.poster = this.coverHorizontalUrl
      // 初始化字幕
      await this.initSubtitles()
      const playLink = await this.fetchMoviePlayInfo()
      this.handleBuryPlay('playProcess', { stage: 1, autoPlay: this.startClickPlay ? '手动点击' : '自动播放' })
      this.config.url = playLink

      // 初始化清晰度
      this.initDefinition()
      this.pageReady = true
      this.loginTip()
    }
  },
  async mounted() {
    console.log('mounted:', this.$store.state.user, this.$i18n.locale)

    if (!this?.id) {
      // 没有id说明没有获取到剧信息
      return
    }
    if (this.$route.params.episode) {
      const currentEpisode = this.episodeVo.filter((item) => item.id === Number(this.$route.params.episode))[0]
      if (!currentEpisode) return
      this.currentEpisode = currentEpisode
    }
    this.initPlayer()
    if (document.querySelector('.desc')?.getBoundingClientRect()?.height > 63) {
      this.showToggleBtn = true
    }
    this.getDownloadLink()
    document.onfullscreenchange = (a) => {
      console.log('fullscreenchange:', a, document.fullscreenElement)
      const fullScreenElement = document.fullscreenElement || document.mozFullScreenElement
      if (fullScreenElement) {
        console.log('进入全屏')
        this.onVideoFullScreen()
      } else {
        console.log('退出全屏')
        this.onExitVideoFullScreen()
      }
    }
  },
  destroyed() {
    this.player = null
  },
  activated() {
    console.log('activated')
  },
  created() {}
}
</script>

<style lang="sass">
#xxplayer
  width: 600px
  height: 300px
  margin: 0 auto
.detail-wrap
  position: relative
  max-width: 1240px
  min-width: 768px
  margin: 0 auto
  padding-top: 20px
  position: relative
  .detail-content
    height: 538px
    display: flex
    justify-content: center
  .video-wrap
    flex: 1
    // max-width: 100%
    max-width: 860px
    height: 100%
    position: relative
    flex-shrink: 0
    // margin: 0 auto
    video
      width: 100%
      outline: none
    .mask
      position: absolute
      width: 100%
      height: 100%
      left: 0
      top: 0
      background: rgba(0,0,0,0.80)
      @include flex-center
      .tips
        text-align: center
        h2
          font-size: 24px
          font-weight: bold
          color: #FEFEFE
          margin-bottom: 9px
        p
          font-size: 18px
          color: #FEFEFE
          line-height: 24px
          margin-bottom: 15px
        img
          width: 400px
        button
          background: $mainColor
          border-radius: 60px
          font-size: 24px
          padding: 0 53px
          height: 60px
          outline: none
          border: none
          color: #FEFEFE
    .full-login-tip
      position: absolute
      bottom: 74px
      height: 44px
      background: rgba(0,0,0,1)
      border-radius: 0px 8px 8px 0px
      font-weight: bold
      font-size: 14px
      line-height: 44px
      color: $mainTextColor
      padding: 0 20px
      width: max-content
      .active
        cursor: pointer
        color: #995aff
      .text-btn
        color: $mainColor
        cursor: pointer
      .iconfont
        display: inline-block
        margin-left: 14px
        cursor: pointer
  .episodes-wrap
    width: 380px
    background-color: #000
    box-sizing: border-box
    flex-shrink: 0

  .subtitle
    font-size: 24px
    line-height: 1.2
    // 24 - 3
    margin-bottom: 21px
    font-weight: bold
  .info-wrap
    position: relative
    min-height: 260px
    display: flex
    padding: 32px 0 26px
  .info
    width: 860px
    .title
      font-size: 24px
      line-height: 1.2
      font-weight: bold
      color: #DEE4E9
      // 设计图的12 - title的下间距3 - tags得上间距4
      margin-bottom: 10px
    .tags
      font-size: 14px
      color: $mainDescTextColor
      line-height: 120%
      align-items: center
      @include base-flex
      margin-bottom: 10px
      .scroce
        color: $mainColor
        margin-right: 5px
      .icon-imdb
        width: 32px
        height: 16px
        background: #FFB119
        border-radius: 4px
        text-align: center
        line-height: 16px
        font-size: 12px
        color: $shadowColor
      .type-area-cagegory
        color: $mainDescTextColor
        @include ellipsis
    .category-line
      display: block
      font-size: 14px
      line-height: 120%
      color: $mainDescTextColor
      margin-bottom: 20px
    .desc
      color: $mainDescTextColor
      margin-top: 4px
      font-size: 14px
      line-height: 21px
      color: #81868E
      width: 100%
      overflow: hidden
      // @include ellipsis-multi(3)
      // height: auto
      max-height: 84px
      transition: max-height 0.3s linear
      // 40 - 4 -3
      margin-bottom: 33px
      position: relative
      .expand
        color: $mainColor
        background: $backgroundColor2
        cursor: pointer
        position: absolute
        right: 0
        bottom: 0
    .desc-actived
      max-height: none
      overflow: visible
      .expand
        bottom: -16px
  .ercode-wrap
    width: 148px
    margin-left: 120px
    // position: absolute
    // right: 0
    // top: 45px
    img
      width: 100%
      display: block
      border-radius: 12px
      margin-bottom: 10px
    p
      font-weight: bold
      font-size: 24px
      color: #FEFEFE
      text-align: center
      line-height: 120%
      margin-bottom: 14px
  .recommend-list
    @include base-flex
    flex-wrap: wrap
    a
      text-decoration: none
    .video-item
      width: 15.7%
      display: block
      flex-shrink: 0
      margin-right: 1.16%
      margin-bottom: 20px
    .video-item:nth-child(6n+6)
      margin-right: 0
  .other-info
    @include flex-between
    font-size: 12px
    margin-bottom: 12px
  .desc-actived
    max-height: 200px
.seo-wrap
  height: 100px
  overflow: hidden
  position: absolute
  left: 0
  top: 0
  z-index: -1
  opacity: 0
.playDateInfo
  display: inline-block
  @include ellipsis
  font-size: 10px
  line-height: 1.2em
// 播放器全屏遮罩
.full-screen-mask
  width: 100%
  height: 100%
  position: fixed
  z-index: 10000
  top: 0
  right: -100%
  .episodes-module
    width: 420px
    position: fixed
    right: -420px
    top: 0
    background: #000000
    opacity: 0.8
    height: 100%
    padding-left: 21px
    transition: all 0.5s
  .episodes-module-active
    right: 0
  .episode-list-wrap
    // 全屏下的高度
    height: calc(100% - 90px) !important
.full-screen-mask-active
  right: 0
  .episodes-module
    right: 0

@media screen and (max-width: 1440px)
  .detail-wrap
    padding: 30px 20px 0
    .video-wrap
      // max-width: calc(100% - 40px)
</style>
